import *as _ from 'lodash'
import {ModelTermBO} from "./ModelTermBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";

export class ModelTermBOValidations {

    static ValidateEmptyFields(aBO: ModelTermBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            //Validate Model Term Id

            if (aBO.WB_ModelTerm.cif.TERM_TYPE.toLowerCase() === 'intercept') {
                let modelTerm = aBO.WB_ModelTerm.cif
                let coeffCount = 0
                if (modelTerm.WB_MODEL_COEFFICIENT_ID != 0) coeffCount += 1
                if (modelTerm.WB_MODEL_COEFFICIENT_ID2 != 0) coeffCount += 1
                if (modelTerm.WB_MODEL_COEFFICIENT_ID3 != 0) coeffCount += 1
                if (modelTerm.WB_MODEL_COEFFICIENT_ID4 != 0) coeffCount += 1

                if (
                    // aBO.WB_ModelTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT > 1 ||
                    // aBO.WB_ModelTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT == 0 ||
                    coeffCount > 1 || coeffCount == 0
                ) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            type: MessageType.Error,
                            code: 'termType',
                            title: "Term Type must have one Coefficient.",
                            description: "Intelligent Intercept Processing requires the Intercept Term to have exactly one coefficient, therefore this term is not eligble to be considered an Intercept Term. Please change the term definition, or uncheck the “Is Intercept Term?” checkbox.",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('termType')
                }
            }

            if (_.isEmpty(aBO.WB_ModelTerm.cif.TERM_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'termid',
                        title: "Term ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('termid')
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_FUNCTION_ID === 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'functionid',
                        title: "Function ID cannot be none selected",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('functionid')
            }

            if (aBO.WB_ModelTerm.cif.TERM_ID.indexOf(" ") > 0) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'termhasspace',
                        title: "Term ID cannot have space between words, please use underscore to connect words",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('termhasspace')
            }

            let iPredictorCnt = 0
            if (aBO.WB_ModelTerm.cif.WB_MODEL_PREDICTOR_ID!= 0) {
                iPredictorCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_PREDICTOR_ID2 != 0) {
                iPredictorCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_PREDICTOR_ID3 != 0) {
                iPredictorCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_PREDICTOR_ID4 != 0) {
                iPredictorCnt += 1
            }

            if (aBO.WB_ModelTerm.WB_ModelFunctionRow.cif.PREDICTOR_COUNT > iPredictorCnt) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'predictorcount',
                        title: "The number of predictors specified need to match the number of predictors in the function",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('predictorcount')
            }


            let iCoefficientCnt = 0
            if (aBO.WB_ModelTerm.cif.WB_MODEL_COEFFICIENT_ID != 0) {
                iCoefficientCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_COEFFICIENT_ID2 != 0) {
                iCoefficientCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_COEFFICIENT_ID3 != 0) {
                iCoefficientCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_COEFFICIENT_ID4 != 0) {
                iCoefficientCnt += 1
            }
            if (aBO.WB_ModelTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT > iCoefficientCnt) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'coefficientcount',
                        title: "The number of coefficients not match the number of coefficients in the function.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('coefficientcount')
            }

            //constants validation
            let iConstantCnt = 0
            if (aBO.WB_ModelTerm.cif.WB_MODEL_CONSTANT_ID != 0) {
                iConstantCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_CONSTANT_ID2 != 0) {
                iConstantCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_CONSTANT_ID3 != 0) {
                iConstantCnt += 1
            }

            if (aBO.WB_ModelTerm.cif.WB_MODEL_CONSTANT_ID4 != 0) {
                iConstantCnt += 1
            }
            if (aBO.WB_ModelTerm.WB_ModelFunctionRow.cif.CONSTANT_COUNT > iConstantCnt) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'constantCount',
                        title: "Missing constant value. Please select a value for each of the constant fields.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('constantCount')
            }

            resolve()

        })

    }
}